const config = {"region":"eu-central-1","apiUrl":"https://713dz9az9b.execute-api.eu-central-1.amazonaws.com/","userPoolId":"eu-central-1_Yl9PTURMn","userPoolWebClientId":"2ubum5g1skve7ikq296dbp3u9h","authenticationFlowType":"USER_PASSWORD_AUTH"};

export default config;

